module.exports = __webpack_public_path__ + "static/media/learning-cpr-and-first-aid.809908e2.jpg";